import styles from './MarkLink.scss';

import cx from 'classnames';
import React from 'react';
import { CSSTransition } from 'react-transition-group';

import { LogoLink } from 'src/components/LogoLink/LogoLink';

export interface IMarkLink {
  hidden?: boolean;
  children?: never;
}

export const MarkLink: React.FC<IMarkLink> = ({ hidden }) => (
  <CSSTransition
    timeout={400}
    in={!hidden}
    classNames={{
      enter: cx(styles.logo, styles.logoAnimateIn),
      enterDone: styles.logo,
      exit: cx(styles.logo, styles.logoAnimateOut),
      exitDone: cx(styles.logo, styles.logoHidden),
    }}
  >
    <LogoLink
      markOnly
      tabIndex={hidden ? -1 : undefined}
      aria-hidden={hidden ? true : undefined}
      className={cx(styles.logo, { [styles.logoHidden]: hidden })}
    />
  </CSSTransition>
);
